import React from "react";
import OrderField from "../shared/order_field";
import Rooms from "./rooms";
import Meals from "./meals";

const OrderAccomodation = () => {
  return (
    <OrderField title={I18n.t("js.order.fields.accomodation")}>
      <div className="order-form__block-content">
        <div className="rooms-var">
          <div className="row">
            <div className="col-lg-12 rooms-var__item-wrap">
              <h3>
                <i className={`fas fa-bed`}></i>
                {I18n.t("js.order.room_type")}
              </h3>
              <div id="order_configs_area">
                <div className="rooms-var__item">
                  <Rooms />
                </div>
              </div>
              <div id="order_services_area"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 rooms-var__item-wrap">
              <h3>
                <i className={`fas fa-utensils`}></i>
                {I18n.t("js.order.meal")}
              </h3>
              <Meals />
            </div>
          </div>
        </div>
      </div>
    </OrderField>
  );
};

export default OrderAccomodation;
